export enum HealthGraphIdentifierSystem {
  PHARMACY_HEALTHCARE_SERVICE_CORE_RUBY_ID = 'https://coreruby.pharmacy.bbl.health/HealthcareService',
  PHARMACIST_PRACTITIONER_PORTAL_LOGIN_ID = 'https://coreruby.bbl.health/PortalLogin',
  PHARMACIST_PRACTITIONER_CORE_RUBY_ID = 'https://coreruby.bbl.health/Pharmacist',
  PHARMACY_SUPPLIER_CORE_RUBY_ID = 'https://coreruby.pharmacy.bbl.health/Organization',
}
